import AOS from 'aos';
import lozad from 'lozad';
import 'jquery';
import Splide from "@splidejs/splide";
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";


// import 'select2';

export default {
  init() {
    // JavaScript to be fired on all pages
    // Toggle Mobile
    const hamburger = document.querySelector('.hamburger');
    AOS.init();

    const observer = lozad();
    observer.observe();

    // eslint-disable-next-line no-undef
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('is-active');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // When the user scrolls the page, execute myFunction
    window.onscroll = function() {
      scrollQuickLinkNav()
    }

    // Get the navbar
    const quickLinkNav = document.getElementById('quick-links');

    // Get the offset position of the navbar
    const stickyQuickLink = quickLinkNav.offsetTop;

    function scrollQuickLinkNav () {
      if(window.pageYOffset >= stickyQuickLink) {
        quickLinkNav.classList.add('quick-link__sticky')
      }else {
        quickLinkNav.classList.remove('quick-link__sticky')
      }
    }

    ( function( $ ) {
      $("#quick-links").find("a").click(function(e) {
        e.preventDefault();
        const section = $(this).attr("href");
        $("html, body").animate({
          scrollTop: $(section).offset().top
        });
      });
    })( jQuery );

    // Fancybox.show([{ src: "#viplist", type: "inline" }]);
  },
};
